// extracted by mini-css-extract-plugin
export var person = "styles-module--person--SWjI5";
export var name = "styles-module--name--9MbUv";
export var title = "styles-module--title--Zcc__";